export const getApiErrorMessage = (error, fallbackMessage = "Something went wrong") => {
  const data = error?.response?.data;
  if (data?.details && typeof data.details === "object") {
    const detailValue = Object.values(data.details)[0];

    if (Array.isArray(detailValue) && detailValue.length > 0) {
      return detailValue[0];
    }

    if (typeof detailValue === "string" && detailValue.trim()) {
      return detailValue;
    }
  }

  return data?.message || error?.message || fallbackMessage;
};
